"use strict";Object.defineProperty(exports, "__esModule", {value: true});

 const selectIsOnline = (state) => state.auth.connected; exports.selectIsOnline = selectIsOnline

 const selectIsDownloadAvailable = (state) => state.app.isDownloadAvailable; exports.selectIsDownloadAvailable = selectIsDownloadAvailable
 const selectIsAppOutdated = (state) => state.app.isOutdated; exports.selectIsAppOutdated = selectIsAppOutdated
 const selectIsAppOnline = (state) => state.auth.connected; exports.selectIsAppOnline = selectIsAppOnline
 const selectIsAuthed = (state) => state.auth.authed; exports.selectIsAuthed = selectIsAuthed
 const selectIsClientOpen = (state) => state.auth.clientOpen; exports.selectIsClientOpen = selectIsClientOpen
